import { observer } from 'mobx-react-lite';
import { authorizationStore } from '../../../../modules/authorization/authorization.store';
import './styles.scss';

export const TermsPrivacyPiece: React.FC<{
  termsandPrivecy: boolean | undefined;
}> = observer(({ termsandPrivecy }) => {
  const { setShowTerms } = authorizationStore;
  if (termsandPrivecy) {
    return (
      <p className="termsInformationText">
        By continuing you agree to our
        <span
          className="termsInformationWhiteText"
          onClick={() => setShowTerms('terms')}
        >
          Terms of Use
        </span>
        and
        <span
          className="termsInformationWhiteText "
          onClick={() => setShowTerms('privacy')}
        >
          Privacy Policy
        </span>
      </p>
    );
  }
  return <></>;
});
